module.exports = __webpack_public_path__ + "img/industria.04df423a.png";